const env = process.env.NODE_ENV || 'development'

const config = {
    // 开发环境 baseURL 留空：请求走 vue.config.js 的 devServer 代理（后端无 CORS 配置）
    development: {
        // baseURL: 'http://192.168.11.103:19091/ajtools'
          baseURL: 'https://train.aojuai.com/ajtools'
    },
    production: {
        // 生产环境同域部署（qywxweb 放到后端 static 或 nginx 同源路径下）
        baseURL: 'https://train.aojuai.com/ajtools'
    }
}

export default config[env] || config.development
